import React from "react";
import ReactDOM from "react-dom/client";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { init, ErrorBoundary } from "@sentry/react";
import sentryConfig from "./services/sentry";
import { theme } from "./components/muiTheme";
import compose from "./helpers/compose";
import AppProvider from "./AppProvider";
import { ReactQueryProvider } from "./providers/ReactQueryProvider";
import ErrorBoundaryComponent from "./components/errorBoundaries/ErrorBoundaryComponent";

init(sentryConfig);

const Provider = compose([AuthProvider, BrowserRouter]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary
    fallback={({ resetError }) => <ErrorBoundaryComponent  resetError={resetError} />}
    beforeCapture={(scope, error, errorInfo) => {
      scope.setTag('error_boundary', 'react');
      scope.setContext('error_info', errorInfo);
    }}
  >
    <ThemeProvider theme={theme}>
      <ReactQueryProvider>
        <Provider>
          <AppProvider>
            <App />
          </AppProvider>
        </Provider>
      </ReactQueryProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
